// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/nordo-uncontrolled-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/nordo-uncontrolled-procedures/nordo-uncontrolled-procedures.js';

mount([g0]);
